// MGS carousel nav — scrolls the target .mgs-carousel by exactly one card's
// width (including its gap) per click, so cards always rest flush against
// the edge instead of stopping at an arbitrary fractional offset (which is
// what caused uneven-looking spacing around the last card).
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.mgs-carousel-nav__button');
  if (!btn) return;

  var targetId = btn.getAttribute('data-carousel-target');
  var carousel = document.getElementById(targetId);
  if (!carousel) return;

  var item = carousel.querySelector('.mgs-carousel__item');
  if (!item) return;

  var itemWidth = item.getBoundingClientRect().width;
  var gap = parseFloat(getComputedStyle(carousel).columnGap || getComputedStyle(carousel).gap) || 0;
  var step = itemWidth + gap;

  var direction = btn.classList.contains('mgs-carousel-nav__button--prev') ? -1 : 1;

  carousel.scrollBy({ left: step * direction, behavior: 'smooth' });
});
